<button
  app-button
  buttonType="flat"
  buttonTheme="light"
  [matMenuTriggerFor]="sortActions">
  <span class="hide-sm">
    {{ selection.label }}
  </span>

  <span class="show-sm">
    Sort
  </span>
  
   <fa-icon icon="caret-down" class="ml-1"></fa-icon>
</button>

<mat-menu #sortActions="matMenu">
  <button
    mat-menu-item
    *ngFor="let item of bookmarkSort"
    (click)="handleItemClick(item)">
    {{ item.label }}
  </button>
</mat-menu>